import React, { useEffect, useCallback } from "react";
import Grid from "../../Utils/Grid";
import { Field, reduxForm } from "redux-form";
import { canCreate, canEdit, canDelete, MODULES } from "../../../../utility/permissions";
import Title from "../../Utils/Headers/Title";
import { standardActions } from "../../Utils/Grid/StandardActions";
import {
    ROLE_ADMIN,
    ROLE_ADMIN_STATION,
    ROLE_CABIN_ATTENDANT,
    ROLE_STATION_BOSS,
    STATUS_EMERGENCY,
} from "../../../../utility/constants";
import CustomSelectFIeld from "../../Utils/FieldFilters/SelectField";
import { SelectField } from "../../Utils/renderField/renderField";
import Filters from "../../Utils/Filters/Filters";
import Swal from "sweetalert2";
import CustomDropdown from "../../Utils/renderField/customDropdown";
import { Fragment } from "react";
import { useRealtimeRefresh } from "../../../hooks/useRealtimeRefresh";
import "./emergencies-list.css";
import { debounce } from "lodash";

const List = (props) => {
    const {
        data,
        loader,
        listar,
        searchChange,
        eliminar,
        me,
        station,
        setStation,
        setTypeEmergency,
        setTypeVehicle,
        vehicle,
        emergency_type_id,
        initializeFilterStatus,
        customListar,
        setStartDate,
        start_date,
        setEndDate,
        end_date,
        filterByRegion,
        region,
        updatePatch,
        descargarExcel,
        excelLoading,
        excelProgress,
    } = props;

    const [showPatients, setShowPatients] = React.useState(false);

    // Create a debounced version of searchChange
    const debouncedSearch = useCallback(
        debounce((value) => {
            searchChange(value);
        }, 500),
        [searchChange]
    );

    useEffect(() => {
        initializeFilterStatus();
        // searchChange("");
        customListar();
    }, []);

    // Real-time refresh when a notification is received
    useRealtimeRefresh(() => {
        customListar();
    });

    const alert = (id, data) => {
        return () => {
            Swal.fire({
                title: "¿Esta seguro de cambiar el estado de la emergencia?",
                text: "¡No podrá revertir esta acción!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "¡Sí, cambiar!",
                cancelButtonText: "No, cancelar",
                reverseButtons: true,
                confirmButtonColor: "#0F45C7",
            }).then((result) => {
                if (result.value) {
                    updatePatch(id, data);
                }
            });
        };
    };

    const columns = [
        {
            dataField: "id",
            sort: true,
            text: "Código",
            attrs: { "data-label": "Código" },
            formatter: (cell, row) => <div className="font-weight-bold">#{row.id}</div>,
        },
        {
            dataField: "stations",
            text: "Estación",
            attrs: { "data-label": "Estación" },
            style: { maxWidth: "250px" },
            formatter: (cell, row) => {
                let nameStation = "Sin estaciones Asignadas";
                if (cell && cell.length > 0) {
                    let stations = "";
                    cell.map((station, index) => {
                        const delimiter = index + 1 === cell.length ? "" : ", ";
                        const stationName = station.name || station.station__name || "Estación";
                        stations += stationName + delimiter;
                    });
                    nameStation = stations;
                }
                return <span className="text-dark">{nameStation}</span>;
            },
        },
        {
            dataField: "address",
            sort: true,
            text: "Dirección",
            attrs: { "data-label": "Dirección" },
            formatter: (cell) => <span className="text-dark">{cell}</span>
        },
        {
            dataField: "emergency_type__id",
            sort: true,
            text: "ID Subtipo",
            attrs: { "data-label": "ID Subtipo" },
            formatter: (cell, row) => <div>{row.emergency_type ? row.emergency_type.id : row.emergency_type_id || "N/A"}</div>,
        },
        {
            dataField: "emergency_type__name",
            text: "Tipo",
            sort: true,
            attrs: { "data-label": "Tipo" },
            formatter: (cell, row) => {
                return (
                    <div className="text-dark">
                        {row.emergency_type_text
                            ? row.emergency_type_text
                            : "Sin tipo"}
                    </div>
                );
            },
        },
        {
            dataField: "status",
            sort: true,
            text: "Estado",
            attrs: { "data-label": "Estado" },
            formatter: (cell, row) => {
                let color = "text-success";
                const statusText = row.status_in_text;
                if (row.status == 20) { // activo
                    color = "text-warning";
                } else if (row.status == 30) { // resuelta
                    color = "text-success";
                } else if (row.status == 40) { // solicita apoyo
                    color = "text-danger";
                } else if (row.status == 50) {
                    color = "text-warning"; // Critical uses warning color per original code logic or orange
                } else {
                    color = "text-dark";
                }

                // Restore CustomDropdown logic
                return (
                    <React.Fragment>
                        {me.role === 10 ? (
                            <div className="d-flex align-items-center">
                                <span className={"material-icons " + color} style={{ fontSize: '10px', marginRight: '8px' }}>
                                    fiber_manual_record
                                </span>
                                <span className="status-text">{statusText}</span>
                            </div>
                        ) : (
                            <div className="d-flex">
                                {me.role === ROLE_CABIN_ATTENDANT || me.role === ROLE_ADMIN || me.role == ROLE_STATION_BOSS || me.role == ROLE_ADMIN_STATION ?
                                    <CustomDropdown
                                        rowId={row.id}
                                        color={color}
                                        disabled={me.role !== ROLE_ADMIN && row.status === 30}
                                        title={row.status_in_text}
                                        options={
                                            [
                                                { value: 20, label: "Activo", action: alert(row.id, 20), color: 'text-warning' },
                                                { value: 30, label: "Resuelta", action: alert(row.id, 30), color: 'text-success' },
                                                { value: 50, label: "Critica", action: alert(row.id, 50), color: 'text-warning' },
                                                { value: 40, label: "Solicita apoyo", action: alert(row.id, 40), color: 'text-danger' },
                                            ]
                                        }
                                    /> :
                                    <React.Fragment>
                                        <div className="d-flex align-items-center">
                                            <span className={"material-icons " + color} style={{ fontSize: '10px', marginRight: '8px' }}>fiber_manual_record</span>
                                            <span className="status-text">{row.status_in_text}</span>
                                        </div>
                                    </React.Fragment>
                                }
                            </div>
                        )}
                    </React.Fragment>
                );
            },
        },
        {
            dataField: "attention_date",
            sort: true,
            text: "Fecha de atención",
            attrs: { "data-label": "Fecha de atención" },
            formatter: (cell) => {
                if (!cell) return 'Sin fecha';
                const dateObj = new Date(cell);
                const dateStr = dateObj.toLocaleDateString();
                const timeStr = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
                return (
                    <div className="d-flex flex-column">
                        <span className="text-dark font-weight-bold">{dateStr}</span>
                        <span className="text-muted small">{timeStr}</span>
                    </div>
                );
            }
        },
        {
            dataField: "resolved_date",
            sort: true,
            text: "Fecha de registro",
            attrs: { "data-label": "Fecha de registro" },
            formatter: (cell) => {
                if (!cell) return <span className="text-muted italic">Pendiente</span>;
                const dateObj = new Date(cell);
                const dateStr = dateObj.toLocaleDateString();
                const timeStr = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
                return (
                    <div className="d-flex flex-column">
                        <span className="text-success font-weight-bold">{dateStr}</span>
                        <span className="text-muted small">{timeStr}</span>
                    </div>
                );
            }
        },
        {
            dataField: "actions",
            text: "Acciones",
            attrs: { "data-label": "Acciones" },
            formatter: (cell, row) => {
                const canEditPerm = canEdit(me, MODULES.EMERGENCIES) ||
                    ((me.role === ROLE_ADMIN_STATION || me.role === ROLE_STATION_BOSS) && row.status === 20);
                const canDeletePerm = canDelete(me, MODULES.EMERGENCIES);

                return (
                    <div className="d-flex justify-content-center gap-2">
                        <a
                            className="btn-action btn-view"
                            href={`#/emergency/${row.id}`}
                            title="Ver"
                            style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                        >
                            <span className="material-icons">visibility</span>
                        </a>
                        {canEditPerm && (
                            <button
                                className="btn-action btn-edit"
                                onClick={() => window.location.href = `#/emergency/${row.id}/editar`}
                                title="Editar"
                            >
                                <span className="material-icons">edit</span>
                            </button>
                        )}
                        {canDeletePerm && (
                            <button
                                className="btn-action btn-delete"
                                onClick={() => {
                                    Swal.fire({
                                        title: "¿Está seguro de eliminar esta emergencia?",
                                        text: "¡Esta acción no se puede deshacer y liberará los vehículos asociados!",
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonText: "¡Sí, eliminar!",
                                        cancelButtonText: "No, cancelar",
                                        reverseButtons: true,
                                        confirmButtonColor: "#D33",
                                    }).then((result) => {
                                        if (result.value) {
                                            eliminar(row.id);
                                        }
                                    });
                                }}
                                title="Eliminar"
                            >
                                <span className="material-icons">delete</span>
                            </button>
                        )}
                    </div>
                );
            },
        },
    ];

    if (showPatients) {
        columns.splice(columns.length - 1, 0, {
            dataField: "total_pacients",
            sort: true,
            text: "Pacientes",
            attrs: { "data-label": "Pacientes" },
            formatter: (cell) => <div className="text-center font-weight-bold">{cell || 0}</div>,
        });
    }

    const showCreate = canCreate(me, MODULES.EMERGENCIES);

    return (
        <div className="emergencies-page-container">
            {/* Header */}
            <div className="emergencies-page-header">
                <div className="header-left">
                    <div className="title-section">
                        <h1>Emergencias</h1>
                        <p className="subtitle">Listado General De Emergencias</p>
                    </div>
                </div>
                {showCreate && (
                    <button
                        className="emergencies-create-btn"
                        onClick={() => window.location.href = "#/emergencies/create"}
                    >
                        <span className="material-icons">add_circle_outline</span>
                        Crear Emergencia
                    </button>
                )}
            </div>

            {/* Filters Section */}
            <div className="emergencies-filters-card">
                <div className="row">
                    <div className="col-md-3 mb-3">
                        <div className="emergencies-filter-wrapper">
                            <span className="material-icons filter-icon">filter_alt</span>
                            <Field
                                name="statusEmergency"
                                component={({ input, meta, ...rest }) => (
                                    <select
                                        {...input}
                                        className="form-control"
                                        onChange={(e) => {
                                            input.onChange(e);
                                            props.filter_by_status(e.target.value);
                                        }}
                                    >
                                        <option value="">Estado de Emergencia</option>
                                        {STATUS_EMERGENCY.map((opt, idx) => (
                                            <option key={idx} value={opt.value}>{opt.label}</option>
                                        ))}
                                    </select>
                                )}
                            />
                        </div>
                    </div>
                    <div className="col-md-3 mb-3">
                        <div className="emergencies-filter-wrapper">
                            <span className="material-icons filter-icon">calendar_today</span>
                            <input
                                type="date"
                                className="form-control"
                                value={start_date || ""}
                                onChange={(e) => setStartDate(e.target.value)}
                                placeholder="Fecha inicio"
                            />
                        </div>
                    </div>
                    <div className="col-md-3 mb-3">
                        <div className="emergencies-filter-wrapper">
                            <span className="material-icons filter-icon">calendar_today</span>
                            <input
                                type="date"
                                className="form-control"
                                value={end_date || ""}
                                onChange={(e) => setEndDate(e.target.value)}
                                placeholder="Fecha fin"
                            />
                        </div>
                    </div>
                    <div className="col-md-3 mb-3">
                        <div className="emergencies-toggle-wrapper">
                            <span className="material-icons filter-icon">people</span>
                            <div className="emergencies-toggle-content">
                                <div className="custom-control custom-switch">
                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="showPatientsSwitch"
                                        checked={showPatients}
                                        onChange={(e) => setShowPatients(e.target.checked)}
                                    />
                                    <label className="custom-control-label" htmlFor="showPatientsSwitch">
                                        Mostrar Pacientes
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 mb-3">
                        <div className="emergencies-filter-wrapper">
                            <span className="material-icons filter-icon">business</span>
                            <Filters
                                station={{
                                    show: true,
                                    station: station,
                                    setStation: setStation,
                                    classNameFilter: "",
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-md-3 mb-3">
                        <div className="emergencies-filter-wrapper">
                            <span className="material-icons filter-icon">place</span>
                            <Filters
                                region={{
                                    show: true,
                                    region: region,
                                    filterByRegion: filterByRegion,
                                    classNameFilter: "",
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-md-2 mb-3">
                        <div className="emergencies-filter-wrapper">
                            <span className="material-icons filter-icon">category</span>
                            <Filters
                                emergency_type={{
                                    show: true,
                                    emergency_type: emergency_type_id,
                                    setTypeEmergency: setTypeEmergency,
                                    classNameFilter: "",
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-md-2 mb-3">
                        <div className="emergencies-filter-wrapper">
                            <span className="material-icons filter-icon">directions_car</span>
                            <CustomSelectFIeld
                                valueKey="id"
                                labelKey="plate"
                                nameApiOptions="vehicle"
                                placeholder="Vehículo"
                                value={vehicle}
                                setValue={setTypeVehicle}
                            />
                        </div>
                    </div>
                    <div className="col-md-2 mb-3">
                        <button
                            className="emergencies-export-btn w-100"
                            onClick={() => descargarExcel(showPatients)}
                            disabled={excelLoading}
                        >
                            <span className="material-icons">
                                {excelLoading ? 'hourglass_empty' : 'file_download'}
                            </span>
                            {excelLoading ? 'Generando...' : 'Excel'}
                        </button>
                    </div>
                </div>
            </div>

            {/* Table */}
            <div className="emergencies-table-card">
                <Grid
                    data={data}
                    loading={loader}
                    columns={columns}
                    onPageChange={customListar}
                    onSortChange={props.onSortChange}
                    noDataMessage={"Sin emergencias registradas"}
                />
            </div>
        </div>
    );
};

export default reduxForm({
    form: "ListEmergencies", // a unique identifier for this form
})(List);
